import { Organization } from "@rms-types/modules/organization/entities/organization";

const index = "organization";

const organizationLicenseType = "license-type";
const getOneOrganization = (id: Organization["id"]) => `${index}/${id}`;

const getOrganizationLicenseType = (id: Organization["id"]) => `${getOneOrganization(id)}/${organizationLicenseType}`;
const getOrganizationApplicationDisclosures = (id: Organization["id"]) =>
  `${getOneOrganization(id)}/application-disclosures`;
const getOrganizationNotes = (organizationId: Organization["id"]) =>
  `${getOneOrganization(organizationId)}/organization-note`;
const getOrganizationPayments = (organizationId: Organization["id"]) =>
  `${getOneOrganization(organizationId)}/organization-payment`;
const getOrganizationDisclosureLicenses = (organizationId: Organization["id"]) =>
  `${getOneOrganization(organizationId)}/disclosure-license`;
const getOrganizationApplications = (organizationId: Organization["id"]) =>
  `${getOneOrganization(organizationId)}/applications`;

export const organizationEndpoint = Object.freeze({
  organization: index,
  organizationSideBar: `${index}/organization-sidebar`,
  getOrganizationLicenseType,
  getOneOrganization,
  getOrganizationApplicationDisclosures,
  getOrganizationNotes,
  getOrganizationPayments,
  getOrganizationDisclosureLicenses,
  getOrganizationApplications,
});
